import { Portal } from "@mui/core";
import { Paper, Skeleton, styled } from "@mui/material";

import { StyledLinearProgress } from "components/loader/StyledLinearProgress";
import { PaddedPaper } from "components/surfaces/PaddedPaper";

interface Props {
  footerRef: HTMLDivElement;
  mapOverlayContainer: HTMLDivElement;
}

export function ClimateEffectsPageSkeleton(props: Props) {
  const { footerRef, mapOverlayContainer } = props;
  const numItems = new Array(3).fill(1);

  return (
    <StyledPaddedPaper padding={2} elevation={0}>
      <Skeleton width={"50%"} />
      <Paper className="graphs" elevation={0}>
        {numItems.map((item, i) => (
          <Paper className="graph" elevation={0} key={i}>
            <Skeleton width={"30%"} />
            <Skeleton height={40} />
          </Paper>
        ))}
      </Paper>
      <Skeleton />
      <Paper className="align-bottom" elevation={0}>
        <Skeleton height={200}></Skeleton>
      </Paper>
      <Portal container={footerRef}>
        <StyledPaper className="footer" elevation={0}>
          <Skeleton width={100} />
          <Skeleton width={100} height={40} />
        </StyledPaper>
      </Portal>
      <Portal container={mapOverlayContainer}>
        <StyledLinearProgress />
      </Portal>
    </StyledPaddedPaper>
  );
}

const StyledPaddedPaper = styled(PaddedPaper)`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: ${({ theme }) => theme.spacing(2)};
  .graphs {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    height: 100%;
  }
  .graph {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(1)};
  }
  .MuiSkeleton-root {
    transform: unset;
    transform-origin: unset;
  }
  .align-bottom {
    margin-top: auto;
  }
`;

const StyledPaper = styled(Paper)`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;
  .MuiSkeleton-root {
    transform: unset;
    transform-origin: unset;
  }
`;
